<div class="dashboard-views-table-details" >
    <dashboard-views-table-details-info  
        *ngIf="project!=null && project.target_version == null"
        [project]="project"
    ></dashboard-views-table-details-info>
    <dashboard-views-table-details-artworks
        *ngIf="project!=null && project.target_version != null"
        [project]="project"
    ></dashboard-views-table-details-artworks>
</div>
